import React, { memo, forwardRef, useContext } from 'react';
import cn from 'classnames';
import { ModalContext } from './contexts';
import styles from './styles.module.css';
export const Backdrop = memo(forwardRef(function Backdrop({ children, className, visible, ...props }, ref) {
    const context = useContext(ModalContext);
    if (!context) {
        throw new Error('Modal component has to be placed inside Modal.Overlay');
    }
    const { underlayProps } = context;
    return (React.createElement("div", { ref: ref, className: cn(styles.backdrop, className, {
            [styles.visible]: visible !== false,
        }), ...underlayProps, ...props }, children));
}));
